<div class="container">
  <div class="row">
    <div style="width:100%;" class="ps-0 pe-0">
      <div class="app_card-body">
        <h1 class="header_text">{{ 'APPEALS_STATUS_HEADER' | globalTranslate }}</h1>
        <hr class="mt-0">
        @if (appDetails?.length) {
        <section>
          <p>
            <span [innerHTML]="'APPEAL_STATUS_SUBTITLE' | globalTranslate"></span>
            <span><b [innerHTML]="'APPEAL_STATUS_SUBTITLE_02' | globalTranslate"></b></span>
            <span [innerHTML]="'APPEAL_STATUS_SUBTITLE_03' | globalTranslate"></span>
          </p>
          <p>
            <span [innerHTML]="'APPEAL_STATUS_SUBTITLE_04' | globalTranslate"></span>
            <span><a tabindex="0" (click)="goToEligibilityAppeals()" (keydown.enter)="goToEligibilityAppeals()" class="add-primary-color">{{'APPEAL_STATUS_SUBTITLE_05' | globalTranslate }}</a></span>
          </p>
          <div class="d-none d-lg-block">
            <table class="table w-100">
              <thead>
                <tr>
                  <th scope="col" style="width:30%;padding-left:2%" class="table-header">{{'APPEAL_STATUS_DETAILS' |
                    globalTranslate}}</th>
                  <th scope="col" style="width:44%" class="table-header">{{'APPEAL_REASON' | globalTranslate}}</th>
                  <th scope="col" style="width:25%;padding-left:3%;" class="table-header">{{'APPEAL_STATUS_DATE' |
                    globalTranslate}}</th>
                  <th scope="col" style="width:35%" [ngClass]="{'table_align': translatedLang !== 'en'}"
                    class="sub_header">{{'APPPEAL_TRACK_STATUS_HEADER' | globalTranslate}}</th>
                </tr>
              </thead>
              <tbody>
                @for (record of paginatedData; track record; let i = $index) {
                <tr [ngClass]="{'odd-row' : i % 2 === 0, 'even-row': i % 2 !== 0 }">
                  <td style="width:25%;">{{record?.memberName}}<br>
                    <strong>{{'Appeal' | globalTranslate}} #:</strong> {{record?.appealNum}}
                  </td>
                  <td style="width:25%;padding-left:4%">
                    @if(translatedLang === 'sp'){
                    {{record?.appealReason?.spValue | globalTranslate}}
                    } @else{
                    {{record?.appealReason?.value | globalTranslate}}
                    }
                  </td>
                  <td style="width:25%;">{{record?.submissionDateOnly}}</td>
                  <td tabindex="0" class="track_app" role="button" [attr.aria-expanded]="expandedIndex === i"
                    [attr.aria-controls]="'status-details-' + i"
                    [attr.aria-label]="(expandedIndex === i ? ('COLLAPSE_TRACK_SUBMISSION' | globalTranslate) : ('EXPAND_TRACK_SUBMISSION' | globalTranslate)) + ' ' + ('Appeal' | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.appealNum"
                    (click)="toggleExpand(i, record?.appealNum)" (keydown.enter)="toggleExpand(i, record?.appealNum)"
                    (keydown.space)="$event.preventDefault(); toggleExpand(i, record?.appealNum)">
                    <span class="track_app_inline">
                      <span [ngStyle]="{'font-size': globalLanguage === 'tl' ? '14px' : 'inherit'}">{{'APPEAL_TRACK'
                        | globalTranslate}}</span>
                      <mat-icon [ngClass]="{'toggle' : expandedIndex === i }"
                        [attr.aria-hidden]="true">keyboard_arrow_down</mat-icon>
                    </span>
                  </td>
                </tr>
                @if (expandedIndex === i) {
                <tr class="status-details" [ngClass]="{'odd-row' : i % 2 === 0, 'even-row': i % 2 !== 0 }"
                  [attr.id]="'status-details-' + i" role="region"
                  [attr.aria-label]="('APP_STATUS_DETAILS' | globalTranslate) + ' ' + ('Appeal' | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.appealNum">
                  <td colspan="6" class="pt-0">
                    @if (record?.appealStatus) {
                    <div class="tracker-container">
                      @for (status of getTrackerSteps(record); track status; let idx = $index; let last = $last) {
                      <div class="step-wrapper"
                        [style.min-width]="status.toUpperCase().startsWith('HEARING HELD') && !shouldShowDashed(status, record.currentAppealStatus.toUpperCase()) ? '200px' : null" [ngClass]="{'last_step_chevron': last && getStatusClass(status, record.currentAppealStatus.toUpperCase()) !== 'past-status'}">
                        <!-- Dashed border for BOTH pending + upcoming -->
                        @if (shouldShowDashed(status, record.currentAppealStatus.toUpperCase())) {
                        <div class="border-overlay">
                          <svg viewBox="0 0 100 100" preserveAspectRatio="none">
                            @if (idx === getTrackerSteps(record).length - 1) {
                            <!-- Last step: V start → Flat end -->
                            <path d="M 0,0 L 100,0 L 100,100 L 0,100" />
                            } @else {
                            <path d="M 0,0 L 85,0 L 100,50 L 85,100 L 0,100" />
                            }
                          </svg>
                        </div>
                        }
                        <div class="step-shape"
                          [ngClass]="getStatusClass(status, record.currentAppealStatus.toUpperCase())"
                          [ngStyle]="getStepStyle(status, record.currentAppealStatus.toUpperCase(), idx, getTrackerSteps(record).length)">
                          <div class="step-content" [ngClass]="{
                                   'align_text': status.toUpperCase() === 'INFORMATION NEEDED' || status.toUpperCase() === 'NOTICE OF HEARING SENT',
                                   'info_left_align': status.toUpperCase() === 'INFORMATION NEEDED'
                                 }">
                            @if (shouldShowClock(status, record.currentAppealStatus.toUpperCase())) {
                            <!-- Clock icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 13.223 13.223">
                              <g transform="translate(-63.5 -63.5)">
                                <path d="M70.111,64a6.111,6.111,0,1,0,6.111,6.111A6.113,6.113,0,0,0,70.111,64Z"
                                  fill="none" stroke="#174a7c" stroke-width="1.2" />
                                <path d="M256,128v4.584h3.056" transform="translate(-185.889 -61.963)" fill="none"
                                  stroke="#174a7c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" />
                              </g>
                            </svg>
                            } @else if(getStatusClass(status, record.currentAppealStatus.toUpperCase()) ===
                            'past-status'){
                            <!-- <span> -->
                            <span class="complete_checkmark">
                              <svg xmlns="http://www.w3.org/2000/svg" width="15.723" height="15.723"
                                viewBox="0 0 15.723 15.723">
                                <g id="checkmark-circle-outline_1_" data-name="checkmark-circle-outline (1)"
                                  transform="translate(-63.25 -63.25)">
                                  <path id="Path_690" data-name="Path 690"
                                    d="M78.223,71.111a7.111,7.111,0,1,0-7.111,7.111A7.113,7.113,0,0,0,78.223,71.111Z"
                                    fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1.5" />
                                  <path id="Path_691" data-name="Path 691" d="M167.111,176l-4.978,5.926L160,179.556"
                                    transform="translate(-92.444 -107.852)" fill="none" stroke="#fff"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                </g>
                              </svg>
                            </span>
                            <span>
                              {{ getStatusLabel(status) | globalTranslate }}
                            </span>
                            } @else {
                            @if (status.toUpperCase() === 'INFORMATION NEEDED' && getStatusClass(status,
                            record.currentAppealStatus.toUpperCase()) === 'highlighted-red') {
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
                            <path id="Combined_Shape" data-name="Combined Shape"
                              d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75Zm7.313,4.308A.937.937,0,1,1,9.75,15,.937.937,0,0,1,8.813,14.058ZM9,11.285,8.732,5.567A1.018,1.018,0,0,1,9.74,4.5h.049a1.02,1.02,0,0,1,.978,1.066L10.5,11.285a.75.75,0,0,1-1.5,0Z"
                              fill="#fff" />
                          </svg>
                            }
                            {{ getStatusLabel(status) | globalTranslate }}
                            }
                          </div>
                        </div>

                        <!-- Active badge -->
                        @if (getStatusClass(status, record.currentAppealStatus.toUpperCase()) === 'current-status' || getStatusClass(status, record.currentAppealStatus.toUpperCase()) === 'highlighted-red') {
                          @if(record.currentAppealStatus.toUpperCase() === 'INFORMATION NEEDED') {
                            <div class="step-badge info_step_badge">{{'APPEAL_STEP_ACTIVE' | globalTranslate }}</div>
                          } @else {
                            <div class="step-badge">{{'APPEAL_STEP_ACTIVE' | globalTranslate }}</div>
                          }
                        }
                      </div>
                      }
                    </div>

                    <!-- Popover -->
                    @if (hasUpcomingSteps(record.currentAppealStatus.toUpperCase()) &&
                    record.currentAppealStatus.toUpperCase() !== 'CLOSED' && (record.currentAppealStatus.toUpperCase()
                    !== 'ORDER ISSUED' && record.currentAppealStatus.toUpperCase() !== 'PETITION PENDING' &&
                    record.currentAppealStatus.toUpperCase() !== 'HEARING HELD - AWAITING JUDGE\'S DECISION')) {
                    <div class="popover-container"
                      [style.padding-left]="getPopoverLeftOffset(record.currentAppealStatus.toUpperCase())">
                      <div class="popover">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 13.223 13.223">
                          <g transform="translate(-63.5 -63.5)">
                            <path d="M70.111,64a6.111,6.111,0,1,0,6.111,6.111A6.113,6.113,0,0,0,70.111,64Z" fill="none"
                              stroke="#174a7c" stroke-width="1.2" />
                            <path d="M256,128v4.584h3.056" transform="translate(-185.889 -61.963)" fill="none"
                              stroke="#174a7c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" />
                          </g>
                        </svg>
                        <p class="popover-text">
                          {{'APPEAL_CALL_OUTBOX' | globalTranslate}}
                        </p>
                      </div>
                    </div>
                    }
                    }

                    @else {
                    @if (!record?.appealStatus) {
                    <p class="text_size web_align">{{'NO_STATUS_TEXT' | globalTranslate }}</p>
                    }
                    }

                    @if (record.currentAppealStatus.toUpperCase() === 'SUBMITTED') {
                    <p class="text_size">
                      <span>{{'APPEAL_STATUS_SUBMITTED' | globalTranslate}}</span>
                    </p>
                    }
                    @if (record.currentAppealStatus.toUpperCase() === 'APPEAL REGISTRATION') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_RIP' | globalTranslate}}</span>
                    </p>
                    }

                    @if (record.currentAppealStatus.toUpperCase() === 'APPEAL UNDER REVIEW') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_AIUR' | globalTranslate}}</span>
                    </p>
                    }
                    @if (record.currentAppealStatus.toUpperCase() === 'INFORMATION NEEDED') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_IN' | globalTranslate }}
                        <a tabindex="0" (click)="goToDocuments(record?.appealNum)" (keydown.enter)="goToDocuments(record?.appealNum)"
                          class="add-primary-color">{{'APPEALS_STATUS_IN_01' | globalTranslate }}</a>
                        <span [innerHTML]="'APPEALS_STATUS_IN_02' | globalTranslate"></span>
                      </span>
                    </p>
                    }
                    @if (record.currentAppealStatus.toUpperCase() === 'SCHEDULING HEARING') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_SH' | globalTranslate}}</span>
                    </p>
                    }
                    @if (record.currentAppealStatus.toUpperCase() === 'NOTICE OF HEARING SENT') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_NOHS' | globalTranslate }}
                        <a tabindex="0" (click)="goToEligibilityAppeals(record?.appealNum)" (keydown.enter)="goToEligibilityAppeals(record?.appealNum)" class="add-primary-color">
                          {{'APPEAL_UNDER_REVIEW_01' | globalTranslate }}</a><span
                          [innerHTML]="'APPEALS_STATUS_NOHS_01' | globalTranslate"></span></span>
                    </p>
                    }
                    @if (record.currentAppealStatus.toUpperCase() === "HEARING HELD - AWAITING JUDGE'S DECISION") {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_HH_AJD' | globalTranslate}}</span>
                    </p>
                    }
                    @if (record.currentAppealStatus.toUpperCase() === 'ORDER ISSUED') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_OI' | globalTranslate}}</span>
                      <a tabindex="0" (click)="goToMyLetters(record?.appealNum)" (keydown.enter)="goToMyLetters(record?.appealNum)" class="add-primary-color">{{'MY_LETTERS' |
                        globalTranslate }}</a>
                      <span>{{'APPEALS_STATUS_OI_01' | globalTranslate}}</span>
                    </p>
                    }@if (record.currentAppealStatus.toUpperCase() === 'PETITION PENDING') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_PP' | globalTranslate}}</span>
                    </p>
                    }
                    @if (record.currentAppealStatus.toUpperCase() === 'CLOSED') {
                    <p class="text_size">
                      <span>{{'APPEALS_STATUS_CLOSED' | globalTranslate }}
                        <a tabindex="0" (click)="goToEligibilityAppeals(record?.appealNum)" (keydown.enter)="goToEligibilityAppeals(record?.appealNum)"
                          class="add-primary-color">{{'APPEAL_UNDER_REVIEW_01' | globalTranslate }}</a>
                        <span [innerHTML]="'APPEALS_STATUS_CLOSED_01' | globalTranslate"></span>
                      </span>
                    </p>
                    }
                  </td>
                </tr>
                }
                }
              </tbody>
            </table>
            @if (this.appDetails?.length > 5) {
            <div class="custom-pagination">
              <button (click)="changePage(1)" [disabled]="currentPage === 1"
                [ngClass]="{'next-page': currentPage !== 1}" [attr.aria-label]="'Go to first page'"><span
                  aria-hidden="true">
                  <<< </span></button>
              <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
                [ngClass]="{'next-page': currentPage !== 1}" [attr.aria-label]="'Go to previous page'"><span
                  aria-hidden="true">
                  << </span></button>
              @for (page of pages; track page) {
              <button (click)="changePage(page)" [ngClass]="{'active-page': page === currentPage}"
                [attr.aria-label]="page === currentPage ? 'Page ' + page + ', current page' : 'Go to page ' + page"
                [attr.aria-current]="page === currentPage ? 'page' : null">
                <span class="page_num" aria-hidden="true">{{page}}</span>
              </button>
              }
              <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
                [ngClass]="{'next-page': currentPage !== totalPages}" [attr.aria-label]="'Go to next page'"><span
                  aria-hidden="true">></span>
              </button>
              <button (click)="changePage(totalPages)" [disabled]="currentPage === totalPages"
                [ngClass]="{'next-page': currentPage !== totalPages}" [attr.aria-label]="'Go to last page'"><span
                  aria-hidden="true">>></span></button>
            </div>
            }
          </div>
          <div class="nh-table-mobile d-lg-none">
            @for (record of appDetails; track record; let i = $index) {
            <div>
              <div class="table-row mb-3 pb-3 item active">
                <div class="mobile-table-header">{{'APPEAL_STATUS_DETAILS' | globalTranslate}}</div>
                <hr>
                <div class="mobile-table-data">{{record?.memberName}}<br><strong>{{'Appeal' | globalTranslate}}
                    #:</strong> {{record?.appealNum}}</div>
                <br>
                <div class="mobile-table-header">{{'APPEAL_REASON' | globalTranslate}}</div>
                <hr>
                <div class="mobile-table-data">
                  @if(translatedLang === 'sp'){
                  {{record?.appealReason?.spValue | globalTranslate}}
                  } @else{
                  {{record?.appealReason?.value | globalTranslate}}
                  }</div>
                <br>
                <div class="mobile-table-header">{{'APPEAL_STATUS_DATE' | globalTranslate}}</div>
                <hr>
                <div class="mobile-table-data">{{record?.submissionDateOnly}}</div>
                <br>
                <div class="mobile-table-header">{{'APPPEAL_TRACK_STATUS_HEADER' | globalTranslate}}</div>
                <hr>
                <div class="mobile-table-data">
                  <div class="track_app" role="button" tabindex="0" [attr.aria-expanded]="expandedIndex === i"
                    [attr.aria-controls]="'mobile-status-details-' + i"
                    [attr.aria-label]="(expandedIndex === i ? ('COLLAPSE_TRACK_SUBMISSION' | globalTranslate) : ('EXPAND_TRACK_SUBMISSION' | globalTranslate)) + ' ' + ('Appeal' | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.appealNum"
                    (click)="toggleExpand(i, record?.appealNum)" (keydown.enter)="toggleExpand(i, record?.appealNum)"
                    (keydown.space)="$event.preventDefault(); toggleExpand(i, record?.appealNum)">
                    <span>{{'APPEAL_TRACK' | globalTranslate}}</span>
                    <mat-icon [ngClass]="{'toggle' : expandedIndex === i }"
                      [attr.aria-hidden]="true">keyboard_arrow_down</mat-icon>
                  </div>
                  @if (expandedIndex === i) {
                  <div class="status-details" [attr.id]="'mobile-status-details-' + i" role="region"
                    [attr.aria-label]="('APP_STATUS_DETAILS' | globalTranslate) + ' ' + ('Appeal' | globalTranslate) + ' ' + ('APP_WORD' | globalTranslate) + ' ' + record?.wpAppnumber">
                    <div colspan="3">
                      @if (record?.appealStatus) {
                      <div class="tracker-container-vertical" aria-hidden="true">
                        @for (status of getTrackerSteps(record); track status; let idx = $index; let last = $last) {
                        <div class="step-wrapper-vertical"
                          [style.height]="status.toUpperCase().startsWith('HEARING HELD') && !shouldShowDashed(status, record.currentAppealStatus.toUpperCase()) ? '160px' : null">
                          @if (shouldShowDashed(status, record.currentAppealStatus.toUpperCase())) {
                          <div class="border-overlay-vertical">
                            <svg viewBox="0 0 100 100" preserveAspectRatio="none">
                              @if (last) {
                              <path d="M 0,0 L 100,0 L 100,100 L 0,100 Z" />
                              } @else {
                              <path d="M 0,0 L 100,0 L 100,84 L 50,100 L 0,84 Z" />
                              }
                            </svg>
                          </div>
                          }
                          @if (!last && getStatusClass(status, record.currentAppealStatus.toUpperCase()) ===
                          'past-status') {
                          <!-- V-chevron white line matching clip-path arrow boundary — separates same-color past steps -->
                          <div class="separator-overlay-vertical">
                            <svg viewBox="0 0 100 100" preserveAspectRatio="none">
                              <path d="M 0,84 L 50,100 L 100,84" />
                            </svg>
                          </div>
                          }
                          <div class="step-shape-vertical"
                            [ngClass]="getStatusClass(status, record.currentAppealStatus.toUpperCase())"
                            [style.height]="status.toUpperCase().startsWith('HEARING HELD') && !shouldShowDashed(status, record.currentAppealStatus.toUpperCase()) ? '160px' : null">
                            <div class="step-content"
                              [ngClass]="{
                              'align_text': status.toUpperCase() === 'INFORMATION NEEDED' || status.toUpperCase() === 'NOTICE OF HEARING SENT',

                              'long-label': status.toUpperCase().startsWith('HEARING HELD') && getStatusClass(status, record.currentAppealStatus.toUpperCase()) === 'current-status'}">
                              @if (shouldShowClock(status, record.currentAppealStatus.toUpperCase())) {
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                viewBox="0 0 13.223 13.223">
                                <g transform="translate(-63.5 -63.5)">
                                  <path d="M70.111,64a6.111,6.111,0,1,0,6.111,6.111A6.113,6.113,0,0,0,70.111,64Z"
                                    fill="none" stroke="#174a7c" stroke-width="1.2" />
                                  <path d="M256,128v4.584h3.056" transform="translate(-185.889 -61.963)" fill="none"
                                    stroke="#174a7c" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="1.2" />
                                </g>
                              </svg>
                              } @else if (getStatusClass(status, record.currentAppealStatus.toUpperCase()) ===
                              'past-status') {
                              <span class="complete_checkmark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.723" height="15.723"
                                  viewBox="0 0 15.723 15.723">
                                  <g id="checkmark-circle-outline_1_" data-name="checkmark-circle-outline (1)"
                                    transform="translate(-63.25 -63.25)">
                                    <path id="Path_690" data-name="Path 690"
                                      d="M78.223,71.111a7.111,7.111,0,1,0-7.111,7.111A7.113,7.113,0,0,0,78.223,71.111Z"
                                      fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1.5" />
                                    <path id="Path_691" data-name="Path 691" d="M167.111,176l-4.978,5.926L160,179.556"
                                      transform="translate(-92.444 -107.852)" fill="none" stroke="#fff"
                                      stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                  </g>
                                </svg>
                              </span>
                              <span>{{ getStatusLabel(status) | globalTranslate }}</span>
                              } @else {
                              @if (status.toUpperCase() === 'INFORMATION NEEDED' && getStatusClass(status,
                              record.currentAppealStatus.toUpperCase()) === 'highlighted-red') {
                            <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
                              <path id="Combined_Shape" data-name="Combined Shape"
                                d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75Zm7.313,4.308A.937.937,0,1,1,9.75,15,.937.937,0,0,1,8.813,14.058ZM9,11.285,8.732,5.567A1.018,1.018,0,0,1,9.74,4.5h.049a1.02,1.02,0,0,1,.978,1.066L10.5,11.285a.75.75,0,0,1-1.5,0Z"
                                fill="#fff" />
                            </svg>
                              }
                              {{ getStatusLabel(status) | globalTranslate }}
                              }
                            </div>
                          </div>
                          @if (getStatusClass(status, record.currentAppealStatus.toUpperCase()) === 'current-status' ||
                          getStatusClass(status, record.currentAppealStatus.toUpperCase()) === 'highlighted-red') {
                          @if(record.currentAppealStatus.toUpperCase() === 'INFORMATION NEEDED') {
                          <div class="step-badge-vertical info_step_badge">{{'APPEAL_STEP_ACTIVE' | globalTranslate }}</div>
                          } @else {
                          <div class="step-badge-vertical">{{'APPEAL_STEP_ACTIVE' | globalTranslate }}</div>
                          }
                          }
                        </div>
                        }
                      </div>
                      @if (hasUpcomingSteps(record.currentAppealStatus.toUpperCase()) &&
                      record.currentAppealStatus.toUpperCase() !== 'CLOSED' && (record.currentAppealStatus.toUpperCase()
                      !== 'ORDER ISSUED' && record.currentAppealStatus.toUpperCase() !== 'PETITION PENDING' &&
                      record.currentAppealStatus.toUpperCase() !== 'HEARING HELD - AWAITING JUDGE\'S DECISION')) {
                      <div class="popover-container-vertical">
                        <div class="popover-vertical">
                          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 13.223 13.223">
                            <g transform="translate(-63.5 -63.5)">
                              <path d="M70.111,64a6.111,6.111,0,1,0,6.111,6.111A6.113,6.113,0,0,0,70.111,64Z"
                                fill="none" stroke="#174a7c" stroke-width="1.2" />
                              <path d="M256,128v4.584h3.056" transform="translate(-185.889 -61.963)" fill="none"
                                stroke="#174a7c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" />
                            </g>
                          </svg>
                          <p class="popover-text">{{'APPEAL_CALL_OUTBOX' | globalTranslate}}</p>
                        </div>
                      </div>
                      }
                      } @else {
                      @if (!record?.appealStatus) {
                      <p class="text_size mobile_align">{{'NO_STATUS_TEXT' | globalTranslate }}</p>
                      }
                      }

                      @if (record.currentAppealStatus.toUpperCase() === 'SUBMITTED') {
                      <p class="text_size">
                        <span>{{'APPEAL_STATUS_SUBMITTED' | globalTranslate}}</span>
                      </p>
                      }
                      @if (record.currentAppealStatus.toUpperCase() === 'APPEAL REGISTRATION') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_RIP' | globalTranslate}}</span>
                      </p>
                      }

                      @if (record.currentAppealStatus.toUpperCase() === 'APPEAL UNDER REVIEW') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_AIUR' | globalTranslate}}</span>
                      </p>
                      }
                      @if (record.currentAppealStatus.toUpperCase() === 'INFORMATION NEEDED') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_IN' | globalTranslate }}
                          <a tabindex="0" (click)="goToDocuments(record?.appealNum)"
                            class="add-primary-color">{{'APPEALS_STATUS_IN_01' | globalTranslate }}</a>
                          <span [innerHTML]="'APPEALS_STATUS_IN_02' | globalTranslate"></span>
                        </span>
                      </p>
                      }
                      @if (record.currentAppealStatus.toUpperCase() === 'SCHEDULING HEARING') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_SH' | globalTranslate}}</span>
                      </p>
                      }
                      @if (record.currentAppealStatus.toUpperCase() === 'NOTICE OF HEARING SENT') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_NOHS' | globalTranslate }}
                          <a tabindex="0" (click)="goToEligibilityAppeals(record?.appealNum)" class="add-primary-color">
                            {{'APPEAL_UNDER_REVIEW_01' | globalTranslate }}</a><span
                            [innerHTML]="'APPEALS_STATUS_NOHS_01' | globalTranslate"></span></span>
                      </p>
                      }
                      @if (record.currentAppealStatus.toUpperCase() === "HEARING HELD- AWAITING JUDGE'S DECISION") {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_HH_AJD' | globalTranslate}}</span>
                      </p>
                      }
                      @if (record.currentAppealStatus.toUpperCase() === 'ORDER ISSUED') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_OI' | globalTranslate}}</span>
                        <a tabindex="0" (click)="goToMyLetters(record?.appealNum)" class="add-primary-color">{{'MY_LETTERS' |
                          globalTranslate }}</a>
                        <span>{{'APPEALS_STATUS_OI_01' | globalTranslate}}</span>
                      </p>
                      }@if (record.currentAppealStatus.toUpperCase() === 'PETITION PENDING') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_PP' | globalTranslate}}</span>
                      </p>
                      }
                      @if (record.currentAppealStatus.toUpperCase() === 'CLOSED') {
                      <p class="text_size">
                        <span>{{'APPEALS_STATUS_CLOSED' | globalTranslate }}
                          <a tabindex="0" (click)="goToEligibilityAppeals(record?.appealNum)"
                            class="add-primary-color">{{'APPEAL_UNDER_REVIEW_01' | globalTranslate }}</a>
                          <span [innerHTML]="'APPEALS_STATUS_CLOSED_01' | globalTranslate"></span>
                        </span>
                      </p>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </section>
        }
        @if (!appDetails.length) {
        <p>{{'APPEAL_NO_DATA' | globalTranslate}}<a tabindex="0" (click)="goToEligibilityAppeals()" (keydown.enter)="goToEligibilityAppeals()"
            class="add-primary-color">{{'APPEAL_STATUS_SUBTITLE_05' | globalTranslate }}</a>&nbsp;{{'APPEAL_NO_DATA_01'
          |
          globalTranslate}}&nbsp;<a tabindex="0" (click)="goToDashboard()" (keydown.enter)="goToDashboard()"
            class="add-primary-color">{{'APPEAL_NO_DATA_02' | globalTranslate }}</a></p>
        }
      </div>
    </div>
  </div>
</div>